import { ApolloError, ServerError } from '@apollo/client';

export const isRecaptchaError = (error: ApolloError) => {
  const networkError = error?.networkError as ServerError;

  const isCaptchaError =
    (networkError?.result &&
      typeof networkError?.result === 'object' &&
      networkError?.result?.errors?.[0]?.message?.toUpperCase()?.includes('RECAPTCHA')) ||
    error?.message?.includes('RECAPTCHA') ||
    error?.cause?.message.includes('RECAPTCHA');

  return isCaptchaError;
};
